import { IframeReadableStream, IframeFileReadableStream } from '../../stream';
import { StreamType as StreamTypeConstant } from '../../constants';

/**
 * Endpoint Stream integration layer (`src/endpoint/stream`)
 *
 * This directory integrates postMessage `stream_*` messages with the stream object system in `src/stream`:
 * - Parses stream_start and creates the corresponding ReadableStream (data/file)
 * - Does NOT implement the stream protocol itself (protocol lives in `src/stream`)
 */

/**
 * Parsed stream_start body info.
 */

/**
 * Parse stream_start body with defaults.
 */
export function parseStreamStart(body) {
  var _chunked, _autoResolve;
  var b = body;
  if (!(b !== null && b !== void 0 && b.streamId)) return null;
  return {
    streamId: b.streamId,
    type: b.type || StreamTypeConstant.DATA,
    mode: b.mode,
    chunked: (_chunked = b.chunked) !== null && _chunked !== void 0 ? _chunked : true,
    metadata: b.metadata,
    autoResolve: (_autoResolve = b.autoResolve) !== null && _autoResolve !== void 0 ? _autoResolve : false
  };
}

/**
 * Create a readable stream instance from a stream_start message/body.
 *
 * This is shared by:
 * - client side: receiving response stream from server
 * - server side: receiving request-body stream from client
 */
export function createReadableStreamFromStart(params) {
  var _params$secretKey;
  var info = parseStreamStart(params.data.body);
  if (!info) return null;
  var secretKey = (_params$secretKey = params.secretKey) !== null && _params$secretKey !== void 0 ? _params$secretKey : params.data.secretKey;
  if (info.type === StreamTypeConstant.FILE) {
    var _info$metadata, _info$metadata2, _info$metadata3;
    var fileStream = new IframeFileReadableStream(info.streamId, params.requestId, params.handler, {
      chunked: info.chunked,
      metadata: info.metadata,
      secretKey,
      mode: info.mode,
      idleTimeout: params.idleTimeout,
      heartbeat: params.heartbeat,
      filename: (_info$metadata = info.metadata) === null || _info$metadata === void 0 ? void 0 : _info$metadata.filename,
      mimeType: (_info$metadata2 = info.metadata) === null || _info$metadata2 === void 0 ? void 0 : _info$metadata2.mimeType,
      size: (_info$metadata3 = info.metadata) === null || _info$metadata3 === void 0 ? void 0 : _info$metadata3.size
    });
    return {
      stream: fileStream,
      info
    };
  }
  var readableStream = new IframeReadableStream(info.streamId, params.requestId, params.handler, {
    type: info.type,
    mode: info.mode,
    chunked: info.chunked,
    metadata: info.metadata,
    secretKey,
    idleTimeout: params.idleTimeout,
    heartbeat: params.heartbeat
  });
  return {
    stream: readableStream,
    info
  };
}